import React from 'react';
import { ToastContainer } from './ToastContainer';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { removeToast } from '../../store/slices/toastSlice';

export const ToastProvider: React.FC = () => {
  const toasts = useAppSelector((state) => state.toast.toasts);
  const dispatch = useAppDispatch();

  const handleDismiss = (id: string) => {
    dispatch(removeToast(id));
  };

  return <ToastContainer toasts={toasts} onDismiss={handleDismiss} />;
};
